
const Details = () => {

    return (
        <></>
    )

}

export default Details